
const initialState = {
    valuePropositionPending: false,
    valuePropositionFetched: false,
    valuePropositionData: null,
    valuePropositionErorr: null,
    createValuePropositionPending: false,
    createValuePropositionFetched: false,
    createValuePropositionData: null,
    createValuePropositionErorr: null
}

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case 'GET_VALUE_PROPOSITION_PENDING': {
            state = Object.assign({}, state, { valuePropositionPending: true, valuePropositionFetched: false });
            break;
        }
        case 'GET_VALUE_PROPOSITION_FULFILLED': {
            state = Object.assign({}, state, { valuePropositionPending: false, valuePropositionFetched: true, valuePropositionData: action.data });
            break;
        }
        case 'GET_VALUE_PROPOSITION_REJECTED': {
            state = Object.assign({}, state, { valuePropositionPending: false,  valuePropositionFetched: false, valuePropositionData: null, valuePropositionErorr: action.error });
            break;
        }
        case 'CREATE_VALUE_PROPOSITION_PENDING': {
            state = Object.assign({}, state, { createValuePropositionPending: true, createValuePropositionFetched: false });
            break;
        }
        case 'CREATE_VALUE_PROPOSITION_FULFILLED': {
            state = Object.assign({}, state, { createValuePropositionPending: false, createValuePropositionFetched: true, createValuePropositionData: action.data });
            break;
        }
        case 'CREATE_VALUE_PROPOSITION_REJECTED': {
            state = Object.assign({}, state, { createValuePropositionPending: false,  createValuePropositionFetched: false, createValuePropositionData: null, createValuePropositionErorr: action.error });
            break;
        }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/valuePropositionReducer.jsx